import { FormEvent, useState } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import { useForgotPasswordMutation } from "store/api/mobileApi"

import { forgotPassword, onFormValidate, validationInitialState } from "utils/onValidate"

import { ForgotPasswordForm } from "../ForgotPassword/ForgotPasswordForm"

const inputValuesInitialState = {
  email: "",
}

export const OAuthForgotPassword = () => {
  const [triggerForgotPassword, { isLoading }] = useForgotPasswordMutation()
  const [inputValues, setInputValues] = useState(inputValuesInitialState)
  const [error, setError] = useState(validationInitialState)
  const navigate = useNavigate()

  const onInputChange = (event: FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget

    setInputValues(prevState => {
      return { ...prevState, [name]: value }
    })
  }

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()

    if (!onFormValidate(inputValues, forgotPassword, setError)) {
      return
    }

    try {
      await triggerForgotPassword({ email: inputValues.email }).unwrap()

      setInputValues(inputValuesInitialState)
      toast.success("We have emailed your password reset link.")
      navigate("/")
    } catch (e) {
      const error = e as Error
      toast.error(error?.message || "Server error, try again later.")
    }
  }

  return (
    <>
      <Helmet>
        <title>Nuve - Forgot Password</title>
      </Helmet>
      <div>
        <ForgotPasswordForm
          isFetching={isLoading}
          email={inputValues.email}
          errorField={error.field}
          errorMessage={error.message}
          onInputChange={onInputChange}
          onSubmit={onSubmit}
        />
      </div>
    </>
  )
}
